import Enum from '../interfaces/IEnum';

export const ScaleStatus: Enum = {
    enum: {
        NOEVALUABLE: 0,
        PENDING: 1,
        SCALE: 2
    }
};
